import apiEndPointsList from "@/templates/Admin/variants/default/utils/constant/apiEndPointsList";
import { basePost, baseGet, baseDelete, basePut } from "../api/base";
import { get } from "http";
import { getVariableValue } from "framer-motion";

// const ID_PATH = "111111";

const modulesService = {
    createModule: async (id_path: string, body: any) => {
        let response = null;
        try {
            response = await basePost({
                endpoint: apiEndPointsList.module.CREATE_MODULE(id_path),
                body
            });
        } catch (err) {
            response = err;
        }

        return response?.data.data;
    },


    updateModule: async (id_path: string, id: number, body: any) => {
        let response = null;
        try {
            response = await basePut({
                endpoint: apiEndPointsList.module.UPDATE_MODULE(id_path, id),
                body
            });
        } catch (err) {
            response = err;
        }

        return response?.data;
    },

    deleteModule: async (id_path: string, id: number) => {
        let response = null;
        try {
            response = await baseDelete({
                endpoint: apiEndPointsList.module.DELETE_MODULE(id_path, id),
            });
        } catch (err) {
            response = err;
        }

        return response?.data;
    }
}

export default modulesService;
